var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileShield03Duotone = function SvgFileShield03Duotone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9FAFC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28 4H17.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C8 8.56 8 10.24 8 13.6v20.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C12.56 44 14.24 44 17.6 44h12.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C40 39.44 40 37.76 40 34.4V16M28 4l12 12M28 4v12h12M24 36s6-2.86 6-7.15v-5.004l-4.375-1.564a4.82 4.82 0 0 0-3.252 0L18 23.846v5.005C18 33.14 24 36 24 36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FF",
    stroke: "#516B89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M24 36s6-2.86 6-7.15v-5.004l-4.375-1.564a4.82 4.82 0 0 0-3.252 0L18 23.846v5.005C18 33.14 24 36 24 36"
  })));
};
export default SvgFileShield03Duotone;